import { PrivatePageChangeCurrentBlock } from '../../../../store/actions';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, NgModule, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationRoutingService } from '@application-routing';
import { AppState } from '@appStates';
import { BtnTypeColor, ListLazyComponents, TypeDevice } from '@enums';
import { BzProduct, SliderItem } from '@interfaces';
import { ButtonModule, BzProductModule } from '../../../../modules-ui';
import { TranslocoModule } from '@ngneat/transloco';
import { select, Store } from '@ngrx/store';
import { selectFourProducts, selectViewedFourProducts } from '../../../../store/selectors';
import { SharedModule } from '@shared';
import { Observable } from 'rxjs';
import { selectAllBlock } from 'src/app/store/selectors/start.page.selectors';
import { EntryComponentsStartPageModule } from '../../entryComponents/entry-components.module';

@Component({
  selector: 'app-start-page-lending-content',
  templateUrl: './start-page-lending-content.component.html',
  styleUrls: ['./start-page-lending-content.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StartPageLendingContentComponent {
  @ViewChild('favoriteY') public favoriteY: ElementRef;
  @ViewChild('viewedY') public viewedY: ElementRef;
  @ViewChild('slideY') public slideY: ElementRef;

  public colors: typeof BtnTypeColor = BtnTypeColor;
  public listLE = ListLazyComponents;
  public allBloks: Observable<SliderItem[]> = this.store.pipe(select(selectAllBlock));
  public fourFavoriteProducts: Observable<BzProduct[]> = this.store.pipe(select(selectFourProducts));
  public fourViewedProducts: Observable<BzProduct[]> = this.store.pipe(select(selectViewedFourProducts));

  trackById = (_: unknown, item: BzProduct) => item.id;

  constructor(
    private readonly appRoutingService: ApplicationRoutingService,
    private readonly store: Store<AppState>,
    private readonly router: Router
  ) { }

  public openPrivatePageBlock(id: ListLazyComponents, tab: string): void {
    switch (tab) {
      case 'favorite':
        this.store.dispatch(PrivatePageChangeCurrentBlock({ currentBlock: 2 }));
        break;
      case 'viewed':
        this.store.dispatch(PrivatePageChangeCurrentBlock({ currentBlock: 3 }));
        break;
    }
    this.appRoutingService.navigate(id, this.router.routerState.snapshot.url);
  }

  public desktopSort = (a: SliderItem, b: SliderItem) => {
    return a.desktopId > b.desktopId ? 1 : -1;
  };

  public filterSlide = (item: SliderItem) => {
    return item.visible !== TypeDevice.mobile;
  };

}






@NgModule({
  declarations: [
    StartPageLendingContentComponent
  ],
  exports: [
    StartPageLendingContentComponent
  ],
  imports: [
    CommonModule,
    ButtonModule,
    EntryComponentsStartPageModule,
    SharedModule,
    TranslocoModule,
    BzProductModule
  ]
})
export class StartPageLendingModule { }
